import { render } from "./ErrorPage.vue?vue&type=template&id=10fe374e"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
script.render = render

export default script